import { render } from "./DigitalTransformationAdvantages.vue?vue&type=template&id=056a2be5"
import script from "./DigitalTransformationAdvantages.vue?vue&type=script&lang=js"
export * from "./DigitalTransformationAdvantages.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__